//import Libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {storageRef} from '../../../../firebase';

//import Components
import SliderType from './HiddenContent/SliderType';
import NormalType from './HiddenContent/NormalType';
import CardsType from './HiddenContent/CardsType';

//import Style classes
import './ContentCard.css'
import Icons from '../../../../assets/icons/icons';

const CloseButton = (props)=>{
    return <div className="CloseButton" style={props.style} onClick={props.clickHandler}>
                {Icons.close}
            </div>
}

class ContentCard extends Component {

    constructor(props){

        super(props);

        this.state = {
            url : '',
            urls : [],
        }
    }

    componentDidMount(){
        this.loadImageFromStorage()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.data.id !== this.props.data.id) {
            this.loadImageFromStorage();
        }
    }

    loadImageFromStorage = () => {
        storageRef.child(`${this.props.storagePath}/${this.props.data.id}.jpg`).getDownloadURL()
            .then((url) => {
                this.setState({
                    url,
                })
            })
            .catch(e => {
            })
        if(this.props.data.count) {
            const imageCount = this.props.data.count ? this.props.data.count : 0;
            this.setState({
                url: '',
                urls: new Array(imageCount)
            })
            if (imageCount && imageCount > 0) {
                for (let i = 0; i < imageCount; ++i) {
                    storageRef.child(`${this.props.storagePath}/${this.props.data.id}_${i}.jpg`).getDownloadURL()
                        .then((url) => {
                            let urlsCopy = [...this.state.urls];
                            urlsCopy[i] = url;
                            this.setState((prevState) => ({
                                urls: urlsCopy
                            }))
                        })
                        .catch(e => {
                        })
                }
            }
        }
        else if(this.props.data.items) {
            const imageCount = this.props.data.items ? this.props.data.items.length : 0;
            this.setState({
                url: '',
                urls: new Array(imageCount)
            })
            if (imageCount && imageCount > 0) {
                for (let i = 0; i < imageCount; ++i) {
                    storageRef.child(`card_images/${this.props.data.items[i]}.jpg`).getDownloadURL()
                        .then((url) => {
                            let urlsCopy = [...this.state.urls];
                            urlsCopy[i] = url;
                            this.setState((prevState) => ({
                                urls: urlsCopy
                            }))
                        })
                        .catch(e => {
                        })
                }
            }
        }
    }
    
    render() {
        let addCardClass = "";
        let addBoxClass = "";
        let animationStyleIndex = this.props.index % 3 + 1;

        if(this.props.open) {
            addCardClass = this.props.data.type+" index"+animationStyleIndex+" open";
            addBoxClass = this.props.data.type+" open";
        }else {
            addCardClass = this.props.data.type+" index"+animationStyleIndex;
            addBoxClass = this.props.data.type+"";
        }

    let hiddenContent;
    switch (this.props.data.type) {
        case "normal":
            hiddenContent = 
                <NormalType data={this.props.data} lang={this.props.lang}/>
            break;
        case "slider":
            hiddenContent =
                <SliderType data={this.props.data} urls={this.state.urls} lang={this.props.lang}/>
            break;
        case "cards":
            hiddenContent =
                <CardsType data={this.props.data} urls={this.state.urls} lang={this.props.lang}/>
            break;
        default:
            break;
    } 

    return(
        <div id={this.props.data.id} className={"ContentCardBox "+addBoxClass}>
            <div className={"ContentCard "+addCardClass} onClick={()=>this.props.clickHandler(this.props.data.id, false, this)}>
                <div className="ContentImage">
                    <div className="ColorOverride"></div>
                    <img src={this.state.url}/>
                </div> 
                {hiddenContent}
                <div className="Content">
                    {Icons.plus}
                    <h3>{this.props.data.name[this.props.lang]}</h3>
                    <p>{this.props.lang === "ko" ? 
                    this.props.data.content[this.props.lang].slice(0, 65)+(this.props.data.content[this.props.lang].length > 65 ? "..." : "") : 
                    this.props.data.content[this.props.lang].slice(0, 90)+(this.props.data.content[this.props.lang].length > 90 ? "..." : "")}</p>
                </div>
                <CloseButton 
                        clickHandler={()=>this.props.clickHandler(this.props.index, true, CloseButton)}/>
            </div>
        </div>
        )
    }
}

export default ContentCard;

ContentCard.propTypes = {
    data : PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/DepartmentModule/Contents/ContentCard/ContentCard.js